import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import type { LoanRecord } from '~/types/loans';
import { journeyStatus } from '~/types/loans';

export const loanUserColumns: ColumnsType<LoanRecord> = [
    {
        title: 'Loan No(VLAN)',
        dataIndex: 'loanApplicationNumber',
        key: 'loanApplicationNumber',
        ellipsis: false,
        render: (loanApplicationNumber: string) => loanApplicationNumber || '-',
    },
    {
        title: 'Phone Number',
        dataIndex: 'phone',
        key: 'phone',
        render: (phone: string) => phone || '-',
    },
    {
        title: 'Customer Name',
        dataIndex: 'customerName',
        key: 'customerName',
    },
    {
        title: 'Current Status',
        dataIndex: 'journeyStatus',
        key: 'journeyStatus',
        sorter: {},
        render: (journeyStatusKey: string) =>
            journeyStatus[journeyStatusKey as keyof typeof journeyStatus] ??
            journeyStatusKey,
    },
    {
        title: 'Email Id',
        dataIndex: 'userEmail',
        key: 'userEmail',
    },
    {
        title: 'PAN',
        dataIndex: 'pan',
        key: 'pan',
    },
    {
        title: 'Loan Type',
        dataIndex: 'type',
        key: 'type',
    },
    {
        title: 'Eligible Loan Amount',
        dataIndex: 'MaxAmount',
        key: 'eligibleLoanAmount',
    },
    {
        title: 'Loan Amount Confirmed',
        dataIndex: 'ConfirmedAmount',
        key: 'ConfirmedAmount',
    },
    {
        title: 'Loan Started At',
        dataIndex: 'createdAt',
        key: 'createdAt',
        render: (createdAt: string) =>
            dayjs(createdAt).format('YYYY-MM-DD HH:mm'),
        sorter: {},
    },
    {
        title: 'Loan Modified At',
        dataIndex: 'updatedAt',
        key: 'updatedAt',
        render: (updatedAt: string) =>
            dayjs(updatedAt).format('YYYY-MM-DD HH:mm'),
        sorter: {},
    },
    {
        title: 'Partner',
        dataIndex: 'partner',
        key: 'partner',
    },
    {
        title: 'Lender',
        dataIndex: 'lender',
        key: 'lender',
        render: (lender: string) => lender || '-',
    },
    {
        title: 'Referrer Id',
        dataIndex: 'referrerId',
        key: 'referrerId',
    },
    {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
    },
];
